<template>
  <li
    :href="route('markencode.brand-typology.index', { slug: word.slug })"
    class="
      col-span-1
      flex
      items-center
      bg-white
      border border-gray-200
      rounded-md
      shadow-sm
      overflow-hidden
    "
  >
    <div
      class="
        shrink-0
        flex
        items-center
        justify-center
        w-7
        h-7
        text-gray-400 text-center text-xl
        leading-5
        font-extralight
        bg-gray-200
      "
    >
      <word-icon :word="word"></word-icon>
    </div>

    <div class="flex-1 px-2 py-1 truncate">
      <div
        class="
          text-gray-900
          leading-5
          font-medium
          hover:text-gray-600
          transition
          ease-in-out
          duration-150
          truncate
          text-xs
          2xl:text-sm
        "
      >
        {{ word.word }}

        <!--zone-color-icons :colors="word.zone_colors" :inline="true"></zone-color-icons-->
      </div>
    </div>

    <div class="shrink-0 flex items-center justify-center">
      <svg
        @click="removeWord(word)"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="
          w-4
          h-4
          mr-1
          text-gray-500
          cursor-pointer
          hover:text-markencode-blue
        "
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </div>
  </li>
</template>

<script>
import ZoneColorIcons from '@/Pages/Markencode/Shared/ZoneColorIcons.vue';
import WordIcon from '@/Pages/Markencode/Shared/WordIcon.vue';

export default {
  components: {
    ZoneColorIcons,
    WordIcon,
  },

  props: {
    word: {
      required: true,
      default: Object,
    },
  },

  methods: {
    removeWord(word) {
      this.$emit('removed', word);
    },
  },
};
</script>